var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LockedModelMetadata_1;
import './lockedCalendar'; // force import for JsonSchemaV2
import { JSON, JsonConverter, JsonSchemaV2, MapConverter } from '@symon-ai/wisepipe-serialize';
import { LockedCalendar } from './lockedCalendar';
import { lockedModelMetadataSchemaValidation } from '../validations.generated';
export const lockedModelMetadataSchema = {
    $id: 'urn:wisepipe-common-computation:LockedModelMetadata',
    type: 'object',
    properties: {
        lockedCalendars: {
            type: 'object',
            additionalProperties: { $ref: 'urn:wisepipe-common-computation:LockedCalendar' }
        },
        step: { type: 'number' },
        requestedCalendarID: { type: 'string' }
    },
    required: ['lockedCalendars'],
    if: { required: ['step'] },
    then: { required: ['requestedCalendarID'] }
};
// stored alongside the model and locked model in s3
let LockedModelMetadata = LockedModelMetadata_1 = class LockedModelMetadata {
    constructor(lockedCalendars, step, requestedCalendarID) {
        this.lockedCalendars = lockedCalendars;
        this.step = step;
        this.requestedCalendarID = requestedCalendarID;
        JSON.validate(this, LockedModelMetadata_1);
    }
    isSameLockedPeriod(calendar) {
        const lockedCalendar = this.lockedCalendars.get(calendar.calendarID);
        return (lockedCalendar != undefined &&
            calendar.calendarID === lockedCalendar.calendarID &&
            calendar.lastLockedPeriod === lockedCalendar.lastLockedPeriod);
    }
};
__decorate([
    JsonConverter(new MapConverter(LockedCalendar))
], LockedModelMetadata.prototype, "lockedCalendars", void 0);
LockedModelMetadata = LockedModelMetadata_1 = __decorate([
    JsonSchemaV2(lockedModelMetadataSchema, lockedModelMetadataSchemaValidation)
], LockedModelMetadata);
export { LockedModelMetadata };
//# sourceMappingURL=lockedModelMetadata.js.map